module.exports = __webpack_public_path__ + "img/ofanaim_yes.eb4060b7.png";